import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=6917c700&scoped=true"
import script from "./Spotlight.vue?vue&type=script&lang=js"
export * from "./Spotlight.vue?vue&type=script&lang=js"
import style0 from "./Spotlight.vue?vue&type=style&index=0&id=6917c700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6917c700",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsHero: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Hero.vue').default})
